import React from "react";
import {
    DndContext,
    closestCenter,
    PointerSensor,
    useSensor,
    useSensors,
} from "@dnd-kit/core";
import {
    arrayMove,
    horizontalListSortingStrategy,
    SortableContext,
    useSortable,
    verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { DeleteOutlined, DragOutlined, LineHeightOutlined } from "@ant-design/icons";

function SortableItem({ layer, index, onDelete, isActive, onClick }) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id: layer.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        border: isActive ? "2px solid red" : "1px solid #ccc",
        background: isActive ? "#fff3f3" : "#fafafa",
        cursor: "grab",
        position: "relative",
        width: 65,
        height: 65
    };

    return (
      <div
        ref={setNodeRef}
        style={style}
        className="image-container"
        onClick={(e) => {}}
      >
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            cursor: "grab",
            zIndex: 99,
          }}
          {...attributes}
          {...listeners}
          onClick={(e) => {
            e.stopPropagation();
            onClick();
          }}
        ></div>
        {/* Delete Button */}
        <div
          className="delete-icon"
          style={{ position: "absolute", top: -2, right: 0, zIndex: 101 }}
          onClick={(e) => {
            e.stopPropagation(); // Prevent delete click from selecting
            onDelete();
          }}
        >
          <DeleteOutlined style={{ cursor: "pointer" }} />
        </div>

        {layer?.isColor ? (
          <div
            style={{
              width: "65px",
              height: "65px",
              backgroundColor: layer?.backgroundUrl,
              position: "relative",
              top: 0,
              left: 0,
              zIndex: index + 1,
              cursor: "grab",
            }}
          />
        ) : (
          <img
            src={layer.imageUrl}
            alt={layer.id}
            className="image-preview object-cover"
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "4px",
              objectFit: "cover",
              userSelect: "none",
              pointerEvents: isDragging ? "none" : "auto", // improves UX
            }}
          />
        )}
      </div>
    );
}

export default function LayersList({ layers, setLayers, currentLayerId, setCurrentLayerId, onLayerSelected, handleDeleteLayer }) {
    // const sensors = useSensors(useSensor(PointerSensor));
    const sensors = useSensors(
        useSensor(PointerSensor, {
          activationConstraint: {
            distance: 5, // don't trigger drag unless moved by 5px
          },
        })
      );

    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (active.id !== over?.id) {
            const draggedIndex = layers.findIndex((l) => l.id === active.id);
            const targetIndex = layers.findIndex((l) => l.id === over?.id);
            setLayers(arrayMove(layers, draggedIndex, targetIndex));
            setCurrentLayerId(targetIndex);
        }
    };

    return (
        <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
        >
            <SortableContext items={layers.map((l) => l.id)} strategy={horizontalListSortingStrategy}>
                {layers.map((layer, index) => (
                    <SortableItem
                        key={layer.id}
                        layer={layer}
                        index={index}
                        onDelete={() => handleDeleteLayer(index)}
                        isActive={index === currentLayerId}
                        onClick={() => onLayerSelected(index)}
                    />
                ))}
            </SortableContext>
        </DndContext>
    );
}